import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Loading from '../components/Loading.jsx';
import { useAuthContext } from '../contexts/AuthContext.jsx';

export default function Signin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { allowedNavigation } = useAuthContext();

  useEffect(() => {
    // Check for returnTo parameter first (e.g., from OAuth callbacks)
    // Only allow ConnectShopifyInitialization for security
    const returnTo = new URLSearchParams(location.search).get('returnTo');
    if (returnTo && (returnTo.startsWith('/connect-shopify-initialization') || returnTo.startsWith('/connect-shopify-success'))) {
      navigate(decodeURIComponent(returnTo), { replace: true });
      return;
    }

    // Otherwise, use normal allowedNavigation logic
    if (allowedNavigation?.length > 0) {
      const currentParams = new URLSearchParams(location.search);
      navigate(`${allowedNavigation[0].href}?${currentParams.toString()}`, { replace: true, preventScrolReset: true});
    } else {
      navigate(`/integrations`);
    }

  }, [allowedNavigation, location.search, navigate]);

  return (
    <Loading />
  );
}
